import { useState, useEffect } from 'react';

const useImportScript = (props) => {
  const { url } = props;

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      setIsLoaded(true);
    };
  }, [url]);

  return { isLoaded };
};

export default useImportScript;
